exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-input .ant-input-number {\n  overflow: clip;\n  height: auto;\n  border-radius: 8px;\n  color: #484848;\n  border: 1px solid rgba(8, 95, 206, 0.25);\n  font-size: 14px;\n  width: 100%;\n  background-color: rgba(233, 241, 251, 0.5);\n}\n.form-input .ant-input-number .ant-input-number-input-wrap > input {\n  height: auto;\n  padding: 8px 12px;\n}", ""]);

// exports
